import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/fastResults';

import GreyhoundRacingFastResultsList from '../components/GreyhoundRacingFastResultsList';

const REFRESH_INTERVAL_MILLIS = 5000;

@standardAsyncConnect([
  {
    dispatch: () => load(),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({fastResults: state.greyhoundRacing.fastResults})
  }
])
@catchLifeCycleErrors
export default class GreyhoundRacingFastResults extends Component {

  static propTypes = {
    fastResults: PropTypes.shape({
      fastResults: PropTypes.arrayOf(PropTypes.shape({
        race_reference: PropTypes.shape({
          id: PropTypes.number.isRequired
        }).isRequired
      })).isRequired
    }),
    dispatch: PropTypes.func.isRequired
  };

  render() {
    return (
      <GreyhoundRacingFastResultsList fastResults={this.props.fastResults}/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingFastResults.js